import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1991cd27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-card-games" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "resume" }

import { withDefaults, computed } from "vue";
import { CardGamesSchema } from "@/schemas/common";
import { getImage, EvenOrOdd } from "@/utils";
import { CardImageText } from "@/components";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCardGames',
  props: {
    items: null,
    gap: { default: "0.5rem" },
    direction: { default: "column" },
    background: { default: "transparent" },
    imageWidth: { default: "90%" },
    paddingInline: { default: "1rem" },
    paddingBlock: { default: "1rem" },
    margin: { default: "2rem" }
  },
  setup(__props: any) {

const props = __props as { items: CardGamesSchema[], gap: string, direction: string, background: string, imageWidth: string, paddingInline: string, paddingBlock: string, margin: string };

_useCssVars(_ctx => ({
  "2b908024": (__props.paddingInline),
  "75cbaed0": (__props.paddingBlock),
  "6618e1ba": (__props.gap),
  "6aefc1b2": (_unref(directionRevert)),
  "4902c13a": (__props.direction),
  "307f99c7": (__props.imageWidth),
  "378cb9ca": (__props.background),
  "33c3984a": (__props.margin)
}))



const directionRevert = computed(() => `${props.direction}-reverse`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['item', _unref(EvenOrOdd)(index)])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(getImage)(item.image.path, item.image.local),
            alt: "image"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(CardImageText), {
            image: item.logo.path,
            "image-local": item.logo.local,
            "image-width": item.logo.width,
            text: item.resume.text,
            "long-text": item.resume.long_text
          }, null, 8, ["image", "image-local", "image-width", "text", "long-text"])
        ])
      ], 2))
    }), 128))
  ]))
}
}

})